'use strict';

var GridToolbarRuleListingController = function GridToolbarRuleListingController($scope, rulesStateService) {
  $scope.isDeleteButtonShown = false;
  $scope.isDuplicateShown = false;
  $scope.onRowSelection = function () {
    $scope.isDeleteButtonShown = rulesStateService.isDeleteButtonVisible();
    $scope.isDuplicateShown = rulesStateService.isDuplicateButtonVisible();
  };
  $scope.duplicateRule = function () {
    $scope.$emit('rule-listing:duplicateRule', rulesStateService.getSelectedRow());
  };
};
GridToolbarRuleListingController.$inject = ['$scope', 'RulesStateService'];
module.exports = GridToolbarRuleListingController;